
  <!-- content begin -->
  <div id="content" class="no-bottom no-top">
    <div id="top"></div>


  <!-- section begin -->
  <section id="subheader" class="text-light" data-bgimage="url(assets/images/background/10.jpg)" data-stellar-background-ratio=".2" style="background: url(assets/images/background/16.jpg) 0% 0px / cover; " >
    <div class="overlay-bg t50" style="background: rgba(30, 30, 30, .5)">

        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1>About the post</h1>
                </div>
            </div>
        </div>

    </div>

</section>
<!-- section close -->



<div class="row notifi_main ">
  <div class="col-md-12">
<h2>
    Mobile Application Developer 
</h2>


  </div>
</div>


    <!-- section begin -->
    <section id="section-services">
        <div class="container">

            <div class="row align-items-center">
    <div class="col-md-12">
      <div class="row sequence">


        <!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
            <div class="feature-box style-2 left">
              <i class="fa fa-graduation-cap"></i>
              <div class="text para_cls">
                <h3>Qualification & Experience: </h3>
                <p> <span class="step_no">1</span>Regular B. Tech or BSC or MSc or MCA or M. Tech degree in Computer Science, IT with minimum 4 years of experience in mobile application development</p>
               
              
  
              </div>
            </div>
          </div>
          <!-- feature box close -->
  
       
  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-history"></i>
      <div class="text para_cls">
        <h3>Preferred:</h3>
        <p> <span class="step_no">1</span> Capable of application development for Android and IOS. </p>
		
       </div>
    </div>
  </div>
  <!-- feature box close -->

  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-history"></i>
      <div class="text para_cls">
        <h3>Technologies:</h3>
        <p> <span class="step_no">1</span> Programming languages: well versed in Java, Kotlin, Objective-C and C++. </p>
		<p> <span class="step_no">2</span> Flutter Framework and DART programming Webservices – REST, SOAP  </p>
        <p> <span class="step_no">3</span> Web Services: REST, SOAP. </p>
		<p> <span class="step_no">4</span> Experience in Flutter Framework and DART programming </p>
        <p> <span class="step_no">5</span> Knowledge in JavaScript, HTML and CSS </p>
        <p> <span class="step_no">6</span> IDE tools:  Experienced in handling any IDE tools such as Atom, XCode, Android Studio, Visual studio - Xamarin.  </p>
       </div>
    </div>
  </div>
  <!-- feature box close -->

  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-money"></i>
      <div class="text para_cls">
        <h3>Remuneration:</h3>
        <p> <span class="step_no">1</span> Rs. 40,000/- per month  (consolidated pay) from which standard TDS will be deducted at source. Not entitled to any other allowance or benefits.  </p>


      </div>
    </div>
  </div>
  <!-- feature box close -->

   <!-- feature box begin -->
   <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-money"></i>
      <div class="text para_cls">
        <h3>Responsibilities:</h3>
        <p> <span class="step_no">1</span> 	Design and develop high-volume, low-latency applications for important systems, delivering high-availability and performance.  </p>
        <p> <span class="step_no">2</span> 	Contribute to all phases of the development lifecycle: concept, design, build, deploy, test, release to app stores and support.  </p>
        <p> <span class="step_no">3</span> 	Diagnose performance issues, fix bugs (including crashes and ANRs) to increase the functionality of the application  </p>
        <p> <span class="step_no">4</span> 	Write well designed, testable, efficient code.  </p>
        <p> <span class="step_no">5</span> 	Ensure designs are following the desired specifications.  </p>
        <p> <span class="step_no">6</span> 	Prepare and produce releases of software components.  </p>
        <p> <span class="step_no">7</span> 	Support continuous improvement by investigating alternatives and technologies and presenting these for architectural review.  </p>
        <p> <span class="step_no">8</span> 	Collaborate with team members to brainstorm about new features and functionalities. </p>
        <p> <span class="step_no">9</span> 	should migrate and adapt existing NIMI web applications to Android and IOS. </p>

      </div>
    </div>
  </div>
  <!-- feature box close -->

  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-calendar"></i>
      <div class="text para_cls">
        <h3>Last Date:</h3>
        <p style="color: red;"><b> Last date for Applying Online 22nd November 2021 </b> </p>
      </div>
    </div>
  </div>
  <!-- feature box close -->

    <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Locations</h3>
        <p><span class="step_no">1</span>Chennai</p>
	
      </div>
    </div>
  </div>
  <!-- feature box close -->
  
    <!-- feature box begin -->
    <div class="col-md-12 feature-box mb40 sq-item wow">
        <div class="feature-box style-2 left">
          <i class="fa fa-money"></i>
          <div class="text para_cls">
            <h3>Skills & Requirements:</h3>
            <p> <span class="step_no">1</span> 	Fluent in programming languages Java, Kotlin  </p>
            <p> <span class="step_no">2</span> 	Knowledge and experience in Flutter Framework and DART programming. </p>
            <p> <span class="step_no">3</span> 	Hands on experience in using 
         
            </p>
            <ul>
                <li> 	RESTful APIs </li>
                <li> 	Designing and developing micro-services architecture and containers. </li>
                <li>	Object oriented analysis, UML and design using common design patterns.</li>
                <li>	development IDE Android Studio, Android SDK, Firebase Test Lab.</li>
                <li>	with offline storage, threading, and performance tuning.</li>
                
            </ul>
            <p> <span class="step_no">4</span> 	Familiarity with push notifications, IOS integration with Flutter.  </p>
            <p> <span class="step_no">5</span> 	Experience using GitHub or similar environment  </p>
            <p> <span class="step_no">6</span> 	Experience with Agile development  </p>
            <p> <span class="step_no">7</span> 	Experience with Material Design and Android UI design principles, patterns and best practices. </p>
            <p> <span class="step_no">8</span> 	Good knowledge of adding third-party libraries. </p>
            <p> <span class="step_no">9</span> 	Ability to understand business requirements and translate them into technical requirements. </p>
            <p> <span class="step_no">10</span> 	Working knowledge of the general mobile landscape, architectures, trends, and emerging technologies. </p>
          </div>
        </div>
      </div>
      <!-- feature box close -->

  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Selection Process:</h3>
        <p><span class="step_no">1</span>Selection will be done on the basis of performance in the personal interview by a selection committee.</p>
		<p><span class="step_no">2</span>Only shortlisted candidates will be called for the interview.</p>
		<p><span class="step_no">3</span>No TA/DA will be paid for attending the interview.</p>
<p><span class="step_no">4</span>At the time of the interview, the candidates shall produce their original certificates for verification. </p>

      </div>
    </div>
  </div>
  <!-- feature box close -->
  
     <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Attendance and leave policy:</h3>
        <p><span class="step_no">1</span>The working hours will be the same as for NIMI.</p>
		<p><span class="step_no">2</span>No extra remuneration shall be paid for working beyond office hours or on Saturdays/Sundays/gazetted holidays.</p>
		<p><span class="step_no">3</span>Compulsory leave in such cases shall be at the discretion of the competent authority. </p>


      </div>
    </div>
  </div>
  <!-- feature box close -->
  
    <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Confidentiality and secrecy :</h3>
        <p><span class="step_no">1</span>The consultant maintain confidentiality and will not divulge any information gathered during the period of engagement with the NIMI to any person who is not authorised to know the same. </p>
		


      </div>
    </div>
  </div>
  <!-- feature box close -->
  
   <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Documents for attending the Test and Interview :</h3>
        <p><span class="step_no">1</span>2 copies of passport size photographs</p>
		<p><span class="step_no">2</span>Original and self attested copies of educational certificates</p>
		<p><span class="step_no">3</span>Original and self attested copies of  Caste certificate  and Aadhar card</p>
		<p><span class="step_no">4</span>Original  and self attested copies of Experience certificates</p>
		


      </div>
    </div>
  </div>
  <!-- feature box close -->
  
  
<!--
  <div class="col-md-12 feature-box mb40 sq-item wow" style="text-align: center;">
    <a href="http://nimiprojects.in/recruitment/register.php" target="_blank" class="btn-custom scroll-to">Apply Now</a>
</div> -->


  <div class="container big_padd">








      </div>


    </div>
    <!-- content close -->




    <style>
      #section-intro{
        background-image: url(assets/images/background/niminew.jpg);
    background-size: cover;
    background-position: 0% 0px;
    height: 80vh !important;
      }
      .notifi_main{
        text-align: center;
        padding: 40px 0px;
      }

      .notifi_main h2{
        border-bottom: 6px solid #F56B55;
    width: fit-content;
    margin: 0 auto;
    padding: 0px 30px;
      }
      .notifi_main .descrip_cls{
        padding: 5px 0px;
    font-weight: 500;
    font-size: 21px;
      }

      .overlay-bg.t50{
        background: rgba(30, 30, 30, .1);
      }

      table{
      width: 100%;
      margin-top: 10px;
    }
    th, td{
      padding: 10px;
    }
    thead{
      background-color: #F56B55;
      color: #fff;
    }
    tr:nth-child(odd){
      background-color: #eee;
    }
    .step_no{
      left: 80px;
    height: 30px;
    width: 30px;
    background-color: #F56B55;
    border-radius: 50%;
    display: inline-block;
    font-size: 18px;
    text-align: center;
    color: #fff;
    margin-right: 10px;
    position: absolute;
    }

    .para_cls p{
      padding-left: 35px;
    }
    .num_marks{
      text-align: center;
    }
    .last_tr{
      background-color: #F56B55 !important;
      color: #fff;
    }
    .notifi_main_table h2{

    width: fit-content;
    margin: 0 auto;
    padding: 50px 30px 10px;
    font-size: 23px;

    }
    .para_main_notify{
      padding: 20px 0px;
    width: 50%;
    margin: 0 auto;
    }
  #section-services{
      padding: 0px !important;
    }
    </style>
